import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import EnhanceHeader from "./EnhanceHeader";
import HeaderQuery from "./HeaderQuery.gql";
import HeaderUserQuery from "./HeaderUserQuery.gql";
import { withShop } from "web/core/shop/ShopContext";
import StoreViewSelector from "theme/modules/User/StoreViewSelector";
import CurrencySelector from "theme/modules/User/CurrencySelector";
import Link from "theme/components/atoms/Typography/Link";
import Logo from "theme/components/atoms/Logo";
import Navigation from "./Navigation/Navigation";
import MenuMainCategories from "./Navigation/Menu/MenuMainCategories";
import useSubNavigation from "./useSubNavigation";
import { withErrorBoundary } from "theme/components/helpers/ErrorBoundary/ErrorBoundary";
import SimpleHeader from "./SimpleHeader";

const Header = (props) => {
  const [subNavRef, selectMenu, renderSubNav] = useSubNavigation();

  return (
    <>
      <header className="header">
        <div className="container header__container">
          <div className="header__store">
            <StoreViewSelector storeView={props.user?.storeView} />
            <CurrencySelector currency={props.shop?.currentCurrency} />
          </div>
          <div className="header__logo">
            <Link to="/" onClick={() => selectMenu(null)}>
              <Logo />
            </Link>
          </div>
          <div className="header__central">
            <div className="desktop-only">
              <MenuMainCategories
                data={props.data}
                selectMenu={selectMenu}
                renderSubNav={renderSubNav}
              />
            </div>
          </div>
          <div className="header__links">
            <Navigation
              data={props.data}
              userData={props.userData}
              selectMenu={selectMenu}
              renderSubNav={renderSubNav}
            />
          </div>
        </div>
      </header>
      <div className="header__sub" ref={subNavRef}></div>
    </>
  );
};

const SmartHeader = compose(
  withErrorBoundary(SimpleHeader),
  withShop(),
  EnhanceHeader({
    HeaderQuery,
    HeaderUserQuery,
  })
)(Header);

SmartHeader.propTypes = {
  categories: PropTypes.array,
  user: PropTypes.object,
};

export default SmartHeader;
